import { PositionModel } from '@cas/types/assets';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { DateTime } from 'luxon';
import { IconColor } from '../markers/icons';

export enum AssetReportingType {
  Reporting = 'Reporting',
  ReportedOver1DayAgo = 'ReportedOver1DayAgo',
  ReportedOver7DaysAgo = 'ReportedOver7DaysAgo',
  LastSeen = 'LastSeen',
}

const getReportingType = (lastReportTime: DateTime): AssetReportingType => {
  const lastReportDiff = lastReportTime.diffNow().as('days');

  if (lastReportDiff < -7) {
    return AssetReportingType.ReportedOver7DaysAgo;
  } else if (lastReportDiff < -1) {
    return AssetReportingType.ReportedOver1DayAgo;
  } else {
    return AssetReportingType.Reporting;
  }
};

const getReportingColor = (reportingType: AssetReportingType | undefined): IconColor => {
  switch (reportingType) {
    case AssetReportingType.Reporting:
      return IconColor.Green;
    case AssetReportingType.ReportedOver1DayAgo:
      return IconColor.Yellow;
    case AssetReportingType.ReportedOver7DaysAgo:
      return IconColor.Red;
    case AssetReportingType.LastSeen:
      return IconColor.Blue;
    default:
      return IconColor.Gray;
  }
};

interface UseAssetReportTimeReturn {
  color: IconColor;
  lastGoodReportTime: DateTime;
}

export const useAssetReportTime = (posG: PositionModel): UseAssetReportTimeReturn => {
  const { parseFromIso } = useLocaleFormatter();

  const lastGoodReportTime = parseFromIso(posG.ts);
  const reportingType = getReportingType(lastGoodReportTime);
  const color = getReportingColor(reportingType);

  return {
    color,
    lastGoodReportTime,
  };
};
